<template>
    <div v-if="visible" class="mc-request" :class="{ 'mc-request--compact': compact }">
        <v-btn small depressed class="mc-request__btn" @click="open">
            <v-icon small left>mdi-swap-horizontal</v-icon>
            Αίτημα αλλαγής ώρας
        </v-btn>

        <v-dialog v-model="dialog" max-width="480" scrollable>
            <v-card>
                <v-card-title class="mc-request__title">
                    <v-icon color="orange darken-2" class="mr-2">mdi-swap-horizontal</v-icon>
                    Αίτημα αλλαγής ώρας
                </v-card-title>
                <v-card-text>
                    <p class="mb-3">
                        Ο αγώνας <b>{{ teamsLabel(match) }}</b> ({{ formatDate(match.matchDatetime) }}) ανταλλάσσει ημέρα, ώρα και γήπεδο
                        με τον αγώνα που θα διαλέξετε. Πρέπει να συμφωνήσουν οι αρχηγοί όλων των ομάδων και στη συνέχεια να εγκρίνει η διοργάνωση.
                    </p>
                    <v-autocomplete
                        v-model="otherMatch"
                        :items="candidates"
                        :loading="candidatesLoading"
                        :item-text="item => `${teamsLabel(item)} ${formatDate(item.matchDatetime)}`"
                        item-value="id"
                        return-object
                        label="Αγώνας για ανταλλαγή"
                        color="orange"
                        item-color="orange"
                        outlined
                        :no-data-text="candidatesLoading ? 'Φόρτωση…' : 'Δεν υπάρχουν διαθέσιμοι αγώνες'"
                        hide-details="auto"
                    >
                        <template v-slot:item="{ item }">
                            <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">{{ teamsLabel(item) }}</v-list-item-title>
                                <v-list-item-subtitle>
                                    {{ formatDate(item.matchDatetime) }}<span v-if="item.arena"> · {{ item.arena.name }}</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </v-autocomplete>
                    <v-textarea
                        v-model="reason"
                        class="mt-4"
                        label="Αιτιολογία (προαιρετικό)"
                        color="orange"
                        outlined
                        auto-grow
                        rows="2"
                        counter="500"
                        maxlength="500"
                        hide-details="auto"
                    />
                    <div v-if="error" class="red--text text-body-2 mt-3">{{ error }}</div>
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                    <v-btn text :disabled="loading" @click="dialog = false">Άκυρο</v-btn>
                    <v-spacer />
                    <v-btn depressed color="orange darken-2" class="white--text" :disabled="!otherMatch" :loading="loading" @click="submit">
                        Αποστολή αιτήματος
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import momentTimezone from 'moment-timezone'
    import matchChangeService from '@/services/matchChange'
    import { errorMessage, formatDate } from '@/utils/matchChange'

    // A captain of one of the two teams asks to swap the slot of the match with another match
    export default {
        name: 'MatchChangeRequestButton',
        props: {
            // needs id, matchDatetime, postponed, team1 and team2
            match: {
                type: Object,
                required: true
            },
            compact: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dialog: false,
                candidates: [],
                candidatesLoading: false,
                otherMatch: null,
                reason: '',
                loading: false,
                error: null
            }
        },
        computed: {
            team() {
                return this.$store.getters.getTeam
            },
            visible() {
                if (!this.$store.getters.getCaptain || !this.team || this.match.postponed || !this.match.matchDatetime) return false
                if (momentTimezone(this.match.matchDatetime).valueOf() <= Date.now()) return false
                return [this.match.team1, this.match.team2].some(team => team && team.id === this.team.id)
            }
        },
        methods: {
            formatDate,
            teamsLabel(match) {
                return `${(match.team1 && match.team1.name) || ''} - ${(match.team2 && match.team2.name) || ''}`
            },
            open() {
                this.dialog = true
                this.error = null
                this.otherMatch = null
                this.candidatesLoading = true
                matchChangeService.getCandidates(this.match.id).then(resp => {
                    this.candidates = (resp && resp.data) || []
                    if (!this.candidates.length) {
                        this.error = 'Δεν υπάρχει αγώνας για ανταλλαγή: ο αγώνας είναι πολύ κοντά ή υπάρχει ήδη ανοιχτό αίτημα αλλαγής.'
                    }
                }).catch(error => {
                    this.candidates = []
                    this.error = errorMessage(error)
                }).finally(() => {
                    this.candidatesLoading = false
                })
            },
            submit() {
                this.loading = true
                this.error = null
                matchChangeService.requestMatchChange({
                    matchId: this.match.id,
                    otherMatchId: this.otherMatch.id,
                    teamId: this.team.id,
                    playerId: this.$store.getters.getPlayer.id,
                    reason: this.reason
                }).then(resp => {
                    this.dialog = false
                    this.reason = ''
                    this.$emit('requested', resp.data)
                    this.$router.push({ name: 'MatchChanges', query: { id: resp.data.id } })
                }).catch(error => {
                    this.error = errorMessage(error, 'Δεν ήταν δυνατή η αποστολή του αιτήματος.')
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
.mc-request {
    margin-top: 8px;
}

.mc-request--compact {
    margin-top: 0;
}

.mc-request__btn {
    text-transform: none;
    letter-spacing: normal;
    font-weight: 700;
    background: #e3f2fd !important;
    color: #1565c0 !important;
}

.mc-request__title {
    font-weight: 800;
    word-break: normal;
}
</style>
